
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coins/[coinId]",
      function () {
        return require("private-next-pages/coins/[coinId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coins/[coinId]"])
      });
    }
  